// extracted by mini-css-extract-plugin
export default {"tableColumn":"AssociatedGroup_tableColumn__wcnB7"};